import { Link } from 'react-router-dom';

import { Button } from '@mui/material';

export interface PayButtonProps {
  text?: string;
  color?: 'secondary' | 'primary';
  url?: string;
}

export const PAY_PAGE = '../../payment/pay';

export default function PayButton(props: PayButtonProps) {
  const { text = 'Pay', color = 'secondary', url = PAY_PAGE } = props;

  return (
    <Button color={color} variant="contained" disableElevation component={Link} to={url}>
      {text}
    </Button>
  );
}
